var map = {
	"./getModules.graphql": "9150",
	"./getModulesNonEditor.graphql": "946d",
	"./instantMessages/getAllMessages.graphql": "54ee",
	"./instantMessages/getUnreadMessages.graphql": "9970",
	"./onAfterSignIn.graphql": "b955",
	"./onBeforePageEnter.graphql": "db3b",
	"./onInitApp.graphql": "3f08"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "adc8";